<template>
  <sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :btnRefreshVisible="false" :linkback="linkback" :pathResource="pathResource">
    <template #toolbar>
      <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Csv</b-button>
    </template>
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <date-filter-component ref="cmpDateFilterComponent"></date-filter-component>
        <b-row class="sa-form-btn-filter">
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <!-- <RsaDynamicBodyAreaComponent ref="cmpRsaDynamicBodyAreaComponent"></RsaDynamicBodyAreaComponent> -->
      <rsa-riepilogo-presenze-list-component ref="cmpRsaRiepilogoPresenzeListComponent" @afterLoadData="onAfterLoadDataRsaRiepilogoPresenzeListComponent" />
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaRiepilogoPresenzeListComponent from "../components/RsaRiepilogoPresenzeListComponent.vue";
import DateFilterComponent from "../../../utility/components/DateFilterComponent.vue";
export default {
  mixins: [UtilityMixin],
  components: { SaPageLayout, RsaRiepilogoPresenzeListComponent, DateFilterComponent },
  data() {
    return {
      pathResource: "/rsapazientepresenze/riepilogo",
      linkback: null,
      items: [],
    };
  },
  mounted() {
    // let me = this;
  },
  methods: {
    onSubmit() {
      let dateFilter = this.$refs.cmpDateFilterComponent.getFilter();

      let filtro = { dataDal: dateFilter.dataDal, dataAl: dateFilter.dataAl };
      this.$refs.cmpRsaRiepilogoPresenzeListComponent.loadData(filtro);
    },
    onRefresh() {
      this.$refs.cmpRsaRiepilogoPresenzeListComponent.init();
    },
    onReset() {
      this.$refs.cmpRsaRiepilogoPresenzeListComponent.loadData();
    },
    onAfterLoadDataRsaRiepilogoPresenzeListComponent(listData) {
      this.items = listData;
    },
    setPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      console.log(tmpPresidio);

      if (tmpPresidio) {
        let presidio = JSON.parse(tmpPresidio);
        this.jsonData.codiceStruttura = presidio.codiceStruttura;
        this.contabilitaTipoDocumentoLoadData(this.jsonData.codiceStruttura);
      }
    },
    onScaricaCsv() {
      var data = [];
      let csvHeaderFinal = [];
      let columnsProperty = [
        { key: "dataNascita", type: "date", label: "Data Nascita", visible: true },
        { key: "cognome", type: "string", label: "Cognome", visible: true },
        { key: "nome", type: "string", label: "Nome", visible: true },
        { key: "identificativo", type: "string", label: "Identificativo", visible: true },
        { key: "aslAppartenenza", type: "string", label: "Asl Appartenenza", visible: true },
        { key: "distrettoAppartenenza", type: "string", label: "Distretto Appartenenza", visible: true },
        { key: "comuneAppartenenza", type: "string", label: "Comune Appartenenza", visible: true },
        { key: "giorniPresenza", type: "string", label: "Giorni Presenza", visible: true },
        { key: "numeroGiorniAssenza", type: "string", label: "Numero Giorni Assenza", visible: true },
        { key: "giorniAssenza", type: "string", label: "Giorno Assenza", visible: true },
        { key: "dataRicovero", type: "date", label: "Data Ricovero", visible: true },
        { key: "dataRicovero", type: "string", label: "Data Ricovero", visible: true },
        { key: "dataScadenzaImpegnativa", type: "date", label: "Data Scadenza Impegnativa", visible: true },
        { key: "dataAutorizzazioneImpegnativa", type: "date", label: "Data Autorizzazione Impegnativa", visible: true },
        { key: "numeroAutorizzazioneImpegnativa", type: "string", label: "Numero Autorizzazione Impegnativa", visible: true },
        { key: "strutturaDenominazione", type: "string", label: "Struttura", visible: true },
        { key: "presidioDenominazione", type: "string", label: "Presidio", visible: true },
      ];
      let ketToInclude = {};

      if (this.items.length > 0) {
        for (let column of columnsProperty) {
          if (!ketToInclude[column.key]) {
            ketToInclude[column.key] = {
              type: column.type ? column.type : "string",
              label: column.label ? column.label : column.key.toUpperCase(),
              visible: column.visible ?? true,
            };
          }
        }
        Object.keys(this.items[0]).forEach((key) => {
          if (ketToInclude[key]) {
            csvHeaderFinal.push(key);
          }
        });
        data.push(csvHeaderFinal);
        this.items.forEach((item) => {
          let row = [];
          csvHeaderFinal.forEach((key) => {
            let valore = item[key];
            if (ketToInclude[key].type == "date") {
              if (valore) {
                valore = UtilityMixin.methods.formatDate(valore);
              }
            }
            row.push(valore);
          });
          data.push(row);
        });
      }
      let dataString = "";
      var csvContent = "";
      data.forEach(function (infoArray, index) {
        dataString = infoArray.join(";");
        csvContent += index < data.length ? dataString + "\n" : dataString;
      });

      // The download function takes a CSV string, the filename and mimeType as parameters
      // Scroll/look down at the bottom of this snippet to see how download is called
      var download = function (content, fileName, mimeType) {
        var a = document.createElement("a");
        mimeType = mimeType || "application/octet-stream";

        if (navigator.msSaveBlob) {
          // IE10
          navigator.msSaveBlob(
            new Blob([content], {
              type: mimeType,
            }),
            fileName
          );
        } else if (URL && "download" in a) {
          //html5 A[download]
          a.href = URL.createObjectURL(
            new Blob([content], {
              type: mimeType,
            })
          );
          a.setAttribute("download", fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          location.href = "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
        }
      };

      download(csvContent, "dowload.csv", "text/csv;encoding:utf-8");
    },
  },
};
</script>
<style scoped></style>
